/**
 * Canonical mapping between UI day names and API day names.
 * UI uses capitalized full names (e.g. "Monday").
 * API uses lowercase full names (e.g. "monday").
 */

const UI_TO_API = {
  Sunday: 'sunday',
  Monday: 'monday',
  Tuesday: 'tuesday',
  Wednesday: 'wednesday',
  Thursday: 'thursday',
  Friday: 'friday',
  Saturday: 'saturday',
};

const API_TO_UI = Object.fromEntries(
  Object.entries(UI_TO_API).map(([ui, api]) => [api, ui]),
);

/**
 * Converts a UI day name to the API format.
 * @param {string} uiDay - e.g. "Monday", "Mon", "MONDAY"
 * @returns {string} Lowercase API day name (e.g. "monday")
 */
export const toApiDayName = (uiDay) => UI_TO_API[uiDay] || uiDay?.toLowerCase();

/**
 * Converts an API day name to the UI format.
 * @param {string} apiDay - e.g. "monday"
 * @returns {string} Capitalized UI day name (e.g. "Monday")
 */
export const toUiDayName = (apiDay) => {
  if (!apiDay) return '';
  return API_TO_UI[apiDay] || apiDay.charAt(0).toUpperCase() + apiDay.slice(1);
};
